import cx from "classnames";
import React from "react";
import { Button, ButtonGroup } from "reactstrap";
import { domId } from "../../util/helpers";

export const PillToggle = ({ options, value, onChange, disabled, readOnly, className, testId }) => {
  return (
    <ButtonGroup data-testid={testId} className={cx("btn-group-pills", className)}>
      {options.map((option) => {
        const selected = option.value === value;
        const optionTestId = domId(option.value) || "blank";

        return (
          <Button
            color={selected ? "blue" : undefined}
            outline={!selected}
            className={cx({ selected })}
            disabled={disabled || readOnly}
            key={option.value}
            data-testid={testId ? `${testId}-${optionTestId}` : undefined}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};
